import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

/**
 * Servicio para el audit log de movimientos de entradas
 */
class AuditLogsService {
  constructor() {
    this.api = axios.create({
      baseURL: `${API_URL}/audit-logs`,
      headers: { 'Content-Type': 'application/json' }
    });

    // Interceptor para agregar token de autenticación
    this.api.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('adminToken');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  // Obtener movimientos con filtros y paginación
  async getAuditLogs(params = {}) {
    try {
      const response = await this.api.get('/', { params });
      return response.data;
    } catch (error) {
      throw new Error(this.getErrorMessage(error, 'Error al cargar el historial de movimientos'));
    }
  }

  // Estadísticas por tipo de movimiento
  async getStats(params = {}) {
    try {
      const response = await this.api.get('/stats', { params });
      return response.data;
    } catch (error) {
      throw new Error(this.getErrorMessage(error, 'Error al cargar estadísticas'));
    }
  }

  // Manejar errores de API
  getErrorMessage(error, defaultMessage) {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 401) {
        return 'No tienes autorización para realizar esta acción';
      }

      if (status === 403) {
        return 'Solo los administradores pueden ver el historial de movimientos';
      }

      if (status === 404) {
        return 'Movimiento no encontrado';
      }

      if (data?.message) {
        return Array.isArray(data.message) ? data.message.join(', ') : data.message;
      }
    }

    if (error.request) {
      return 'No se pudo conectar con el servidor. Verifica tu conexión a internet.';
    }

    return defaultMessage;
  }
}

export const auditLogsService = new AuditLogsService();
export default auditLogsService;
